import React from 'react';
import { TasticProps } from 'frontastic/tastics/types';
import Markdown from 'components/commercetools-ui/organisms/markdown';
import Button from 'components/commercetools-ui/atoms/button';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import Typography from 'components/commercetools-ui/atoms/typography';
import { CASE_STUDY_DOWNLOAD } from 'helpers/constants/events';
import Link from 'components/commercetools-ui/atoms/link';

const ContentstackBlogListTastic = ({ data }: TasticProps<any>) => {
  const blogs = Array.isArray(data?.data?.dataSource) ? data.data.dataSource : [];
  const filteredBlogs = blogs.filter((blog: any) => blog.url?.includes('/case-studies/'));
  const truncateDescription = (text: string, maxLength: number = 150) => {
    if (text.length > maxLength) {
      return `${text.slice(0, maxLength).trim()}...`;
    }
    return text;
  };

  return (
    <div className="flex w-full items-center justify-between px-[20.5px] sm:px-24 lg:px-48 xl:px-60 3xl:px-80">
      <div className="w-full">
        {filteredBlogs.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            {filteredBlogs.map((blog: any, index: any) => {
              const section = blog.sections?.find(
                (sec: any) => sec.section_with_image_text
              )?.section_with_image_text;

              if (!section) {
                return null;
              }

              const cmsCssClass = section.additional_css || '';
              const modifiedUrl = blog.url;
              const handleDownload = (pdfUrl: string) => {
                const link = document.createElement('a');
                link.href = pdfUrl;
                link.download = pdfUrl.split('/').pop() ?? 'download';
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                // @ts-ignore
                window.dataLayer = window.dataLayer || [];
                // @ts-ignore
                window.dataLayer.push({
                  event: CASE_STUDY_DOWNLOAD,
                  file: pdfUrl,
                });
              };

              return (
                <div
                  key={index}
                  className={`block transition-shadow hover:shadow-lg ${cmsCssClass}`}
                  style={{ backgroundColor: '#F3EDE9' }}
                >
                  <Link link={modifiedUrl.startsWith('/') ? modifiedUrl: `/${modifiedUrl}`} >
                    {section.image?.url && (
                      <img
                      src={section.image.url}
                      alt={section.image.description || 'Case Study Image'}
                      className={`w-full h-[200px] sm:h-[250px] md:h-[300px] object-cover ${cmsCssClass}`}
                    />                    
                    )}
                    {section.title && (
                      <div className={`p-8 mt-2 ${cmsCssClass}`}>
                        <Markdown
                          markdown={section.title}
                          className="text-lg font-semibold text-gray-800"
                        />
                      </div>
                    )}
                    {section.description && (
                      <div className={`p-8 ${cmsCssClass}`}>
                        <Markdown
                          markdown={truncateDescription(section.description)}
                          className="text-sm text-gray-600"
                        />
                      </div>
                    )}
                  </Link>
                  {section.ctas &&
                    section.ctas.map(
                      (cta: any, ctaIndex: number) =>
                        cta?.button?.href && (
                          <div className={`mb-10 p-8 ${cmsCssClass}`} key={ctaIndex}>
                            <div
                              onClick={() => handleDownload(cta.button.href)}
                              className="text-decoration-none group"
                              style={{
                                display: 'inline-block',
                              }}
                            >
                              <Button
                                icon={<ArrowDownTrayIcon className="w-24 text-[#666]" />}
                                iconPosition="middle"
                                className="cursor-pointer"
                                style={{
                                  backgroundColor: cta.button_background_color?.hex || '#F3EDE9',
                                  border: `1px solid ${cta.button_border_color?.hex || '#000000'}`,
                                  color: cta.button_text_color?.hex || '#000000',
                                  cursor: 'pointer !important',
                                  padding: '8px 28px',
                                  borderRadius: '0',
                                }}
                              >
                                <Typography
                                  as="span"
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: 'italic',
                                    fontSize: '16px',
                                    lineHeight: '20px',
                                  }}
                                >
                                  {cta.button.title}
                                </Typography>
                              </Button>
                            </div>
                          </div>
                        ),
                    )}
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-center text-gray-500">No case studies available.</p>
        )}
        <div className="mt-40"></div>
      </div>
    </div>
  );
};

export default ContentstackBlogListTastic;
